import { AlertEntry } from "./workbookAnalyticsRulesEngine";

//TODO: consider pushing this out into the Excel relay
export async function navigateToAlert(alert: AlertEntry) {
    try {
        await Excel.run(async (context) => {
            const sheet = context.workbook.worksheets.getItem(alert.sheetId);
            sheet.activate();

            // We want to select the focus range and the highlight ranges.
            // To ensure the focus range is the active cell, we list it first.
            const ranges = [alert.mapping.focusRange, ...alert.mapping.highlightRanges]
                .filter((r, i, self) => r && self.indexOf(r) === i); // Deduplicate and remove empty

            if (ranges.length === 0) return;

            const address = ranges.join(",");
            // getRanges allows selecting multiple disjoint ranges
            const range = sheet.getRanges(address);
            range.select();

            await context.sync();
        });
    } catch (error) {
        console.error("Failed to navigate to alert", error);
    }
}
